var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCelular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono celular"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 12.1875,
    cy: 12.1876,
    r: 12.1876,
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4927 15.1868V6.70867C16.4927 5.76534 15.7273 5 14.784 5H8.71464C7.77131 5 7.00597 5.76534 7.00597 6.70867V15.1868H16.4927ZM11.7464 6.06792C12.0311 6.06792 12.2625 6.2993 12.2625 6.58408C12.2625 6.86886 12.0311 7.10024 11.7464 7.10024C11.4616 7.10024 11.2302 6.86886 11.2302 6.58408C11.2361 6.29337 11.4616 6.06792 11.7464 6.06792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99998 16.2131V17.2929C6.99998 18.2363 7.76533 19.0075 8.70866 19.0075H14.778C15.7213 19.0075 16.4867 18.2422 16.4867 17.2929V16.2131H6.99998ZM11.7463 18.0523C11.4615 18.0523 11.2301 17.8209 11.2301 17.5362C11.2301 17.2514 11.4615 17.02 11.7463 17.02C12.0311 17.02 12.2625 17.2514 12.2625 17.5362C12.2625 17.8209 12.0311 18.0523 11.7463 18.0523Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCelular);
export default __webpack_public_path__ + "static/media/icono-celular.f349922eed20cebae7c631b0d769a652.svg";
export { ForwardRef as ReactComponent };